import React, { PureComponent } from "react";
import { connect } from "react-redux";

class FullScreenLayout extends PureComponent {
  render() {
    return (
      <div>{this.props.children}</div>
    );
  }
}
const mapStateToProps = state => {
  return {
    app: state.customizer,
    user: state.authorizedUser.user,
    socket_user: state.socket.socket_user,
  };
};
export default connect(mapStateToProps, {})(FullScreenLayout);